<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('user.profile.subtitle') }}
        </span>
        <h3 class="page-title">
          {{ $t('user.profile.title') }}
        </h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <user-account-details :isCurrentUser="true" ref="userForm" />
  </d-container>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import SessionService from '_services/common/sessionService';
import UserAccountDetails from '_modules/user/components/UserAccountDetails.vue';
import { _LOAD_MODEL_, MODEL } from '_modules/user/components/UserModel';

export default {
  name: 'user-profile-lite',
  components: {
    UserAccountDetails,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    const user = Object.assign(
      cloneDeep(MODEL),
      SessionService.getLocalData('_user'),
    );
    if (!user.settings.image.url) {
      user.settings.image.url = require('@/assets/images/avatars/enhanced-buzz.jpeg');
    }
    Events.$emit(_LOAD_MODEL_, Object.assign(user));
  },
};
</script>
